module.exports = __webpack_public_path__ + "static/media/medicalMainTitle.1389ce29.jpg";